module.exports = __webpack_public_path__ + "static/media/pexels-flickr-149394-min-final.01b3779e.jpg";